// Third party
import React, { useEffect, useState } from 'react';

// Components
import { Button } from '@/views/components/buttons';
import { ComparisonTopBarNavigation } from '@/views/containers/comparison/ComparisonTopBarNavigation';
import ComparisonTopBarNameMobile from '@/views/containers/comparison/ComparisonTopBarNavigation/ComparisonTopBarNameMobile';

// Hooks
import useScreenSize from '@/hooks/useScreenSize';

// Types
import Comparison from '@/types/comparison';

// Utils
import { formatMessage } from '@/utils/i18n';
import ProposalEditorMobileMenuModal from '@/views/components/modals/proposal-editor-options/ProposalEditorMobileMenuModal';

type MobileHeaderProps = {
  comparison: Comparison;
  isSaving: boolean;
  goBackToComparison: () => void;
  onChangeTemplate: () => void;
  onSaveComparison: () => void;
  redirectToContactPage: () => void;
  refreshTemplate: () => void;
  setComparisonName: (name: string) => void;
};

const MobileHeader = ({
  comparison,
  isSaving,
  goBackToComparison,
  onChangeTemplate,
  onSaveComparison,
  redirectToContactPage,
  refreshTemplate,
  setComparisonName,
}: MobileHeaderProps) => {
  const [showMenuModal, setShowMenuModal] = useState<boolean>(false);
  const { isMobile, isTablet } = useScreenSize();

  useEffect(() => {
    if (!isMobile && !isTablet) {
      setShowMenuModal(false);
    }
  }, [isMobile, isTablet]);

  return (
    <>
      <ComparisonTopBarNavigation
        className="is-proposal"
        leftItems={[
          <Button
            key="ProposalTopBarNavigation.BackButton"
            className="top-bar-button"
            onClick={goBackToComparison}
            aria-label={formatMessage('Proposal.ReturnToComparison')}
            icon="arrow-thin-left"
          />,
        ]}
        middleItems={[<ComparisonTopBarNameMobile comparison={comparison} />]}
        farRightItems={[
          <Button
            key="ProposalTopBarNavigation.MoreButton"
            className="top-bar-button"
            onClick={() => setShowMenuModal(true)}
            aria-label={formatMessage('Proposal.ReturnToComparison')}
            icon="ds-more-vertical"
          />,
        ]}
      />
      <ProposalEditorMobileMenuModal
        comparison={comparison}
        isSaving={isSaving}
        show={showMenuModal}
        goBackToComparison={goBackToComparison}
        onChangeTemplate={onChangeTemplate}
        onCloseModal={() => setShowMenuModal(false)}
        onSaveComparison={onSaveComparison}
        redirectToContactPage={redirectToContactPage}
        refreshTemplate={refreshTemplate}
        setComparisonName={setComparisonName}
      />
    </>
  );
};

export default MobileHeader;
